const CHANNELS_KEY = 'miralink_channels';

const readChannels = () => {
  try {
    return JSON.parse(localStorage.getItem(CHANNELS_KEY) || '[]');
  } catch {
    return [];
  }
};

const writeChannels = (channels) => {
  try {
    localStorage.setItem(CHANNELS_KEY, JSON.stringify(channels));
  } catch {
    throw new Error('Браузер не дал сохранить канал. Проверьте cookies/localStorage и свободное место.');
  }
};

const makeId = () => {
  if (globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const currentUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch {
    return null;
  }
};

export const channelAPI = {
  createChannel: async (token, name, description, avatar, username = null) => {
    const me = currentUser();
    if (!me?.id) {
      throw new Error('Пользователь не найден');
    }

    const channels = readChannels();
    const baseUsername = (username || name || `channel_${Date.now()}`)
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9_]/g, '_')
      .slice(0, 30);
    const safeUsername = baseUsername.length >= 3 ? baseUsername : `channel_${Date.now()}`;

    if (channels.some((channel) => channel.username === safeUsername)) {
      throw new Error('Username канала уже занят');
    }

    const now = new Date().toISOString();
    const channel = {
      id: makeId(),
      name,
      username: safeUsername,
      public_link: `${window.location.origin}/#/@${safeUsername}`,
      description,
      creator: me,
      creator_id: me.id,
      subscribers: [me.id],
      subscribers_count: 1,
      is_subscribed: true,
      avatar: avatar || null,
      created_at: now,
      posts: []
    };

    writeChannels([...channels, channel]);
    return channel;
  },

  getMyChannels: async () => {
    const me = currentUser();
    return readChannels().filter((channel) => channel.creator_id === me?.id || channel.subscribers?.includes(me?.id));
  },

  getRecommendedChannels: async () => {
    const me = currentUser();
    return readChannels().map((channel) => ({
      ...channel,
      subscribers_count: channel.subscribers?.length || 0,
      is_subscribed: Boolean(channel.subscribers?.includes(me?.id))
    }));
  },

  subscribe: async (token, channelId) => {
    const me = currentUser();
    const channels = readChannels().map((channel) => {
      if (channel.id !== channelId) return channel;
      const subscribers = new Set(channel.subscribers || []);
      if (me?.id) subscribers.add(me.id);
      return {
        ...channel,
        subscribers: [...subscribers],
        subscribers_count: subscribers.size,
        is_subscribed: true
      };
    });
    writeChannels(channels);
    return { ok: true };
  },

  unsubscribe: async (token, channelId) => {
    const me = currentUser();
    const channels = readChannels().map((channel) => {
      if (channel.id !== channelId) return channel;
      const subscribers = (channel.subscribers || []).filter((id) => id !== me?.id);
      return {
        ...channel,
        subscribers,
        subscribers_count: subscribers.length,
        is_subscribed: false
      };
    });
    writeChannels(channels);
    return { ok: true };
  },

  createPost: async (token, channelId, content, media = []) => {
    const me = currentUser();
    const now = new Date().toISOString();
    const post = {
      id: makeId(),
      channel_id: channelId,
      author: me,
      content,
      media,
      media_meta: [],
      likes_count: 0,
      is_liked: false,
      comments_count: 0,
      created_at: now
    };

    const channels = readChannels().map((channel) =>
      channel.id === channelId ? { ...channel, posts: [...(channel.posts || []), post] } : channel
    );
    writeChannels(channels);
    return post;
  },

  getFeed: async (token, channelId) => {
    const channel = readChannels().find((item) => item.id === channelId);
    return channel?.posts || [];
  },

  likePost: async () => ({ ok: true }),
  commentPost: async () => ({ ok: true }),
  getComments: async () => []
};
